module.exports = "<div role=\"tabpanel\" class=\"tab-pane v-903c5e2a\" v-class=\"hide:!show\" v-show=\"show\" v-transition=\"{{transition}}\">\n    <content></content>\n  </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Tab.vue
 ** module id = 145
 ** module chunks = 0
 **/